module.exports = __webpack_public_path__ + "assets/img/languageDetection.1cc6d9a5.png";